import React, { useEffect, useState } from 'react';
import Rating from '@mui/material/Rating';
import StarIcon from '@mui/icons-material/Star';
import { Button, Card, CardActions, CardContent, CardHeader, 
        CardMedia, IconButton, Typography } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import EditNoteIcon from '@mui/icons-material/EditNote';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import config from '../../config-site'


const address_api = config[0].address;


// const labels = {
//     0.5: 'خیلی ضعیف',
//     1: 'بی فایده',
//     1.5: 'ضعیف',
//     2: 'پایین',
//     2.5: 'معمولی',
//     3: 'بهتر',
//     3.5: 'خوب',
//     4: 'بسیار خوب',
//     4.5: 'عالی',
//     5: 'بسیار عالی',
// };

// function getLabelText(value) {
//   return `${value} Star${value !== 1 ? 's' : ''}, ${labels[value]}`;
// }

function MatShowItem({MatList}) {
  // function MatShowItem({MatList, onSelectLanguage}) {
    const { authData, authDataGroup, authDataLang } = useAuth();
    const [isAdmin, setIsAdmin] = useState(false);
    // const [viewStatus, setViewStatus] = useState(false);
    const [value, setValue] = React.useState(4);
    const navigate = useNavigate();
    // const [openDialog, setOpenDialog] = useState(false);
    // const [selectedValue, setSelectedValue] = useState();
    //////////////////////////////////////////////////////
    // const [imageLoading, setimageLoading] = useState(true);
    // const counter = useRef(0);
    // const imageLoaded = () => {
    //     counter.current += 1;
    //     if (counter.current >= MatList.length) {
    //         setimageLoading(false);
    //     }
    // }
    //////////////////////////////////////////////////////

    // const handleDialodClose = (value) => {
    //     setSelectedValue(value);
    // };


    // const buyHandler = async () => {
    //     if(authData){
    //         const sellAddMAt = await sellNewMat(authData.token, {
    //             'material': MatList.material.id, 'sell_money': MatList.sell_cash, 'sell_count': 1});
    //         if (sellAddMAt){
    //             NotificationManager.success('به سبد خرید شما اضافه شد');
    //             onSelectLanguage(MatList); 
    //         }else{
    //             NotificationManager.error('متاسفانه خطایی در زمان ثبت محصول وجود دارد');
    //         }
    //     }else{
    //         navigate("/login");
    //     }
    // }

    const editMaterial = () => {
        navigate('/mat-new', {state : MatList.material});
    }

    const editBuyMaterial = () => {
        navigate('/mat-buy-add', {state : MatList});
    }

    const reqFree = () => {
        navigate('/req-free');
    }

    useEffect(() => {
        if(authData?.user){
            setIsAdmin(authData.user?.profile?.is_permium);
        }
        
    }, [authData, authDataLang])

    
    return (
      <div dir={authDataLang?.view_sts ? "rtl" : "ltr"}>
          <Card sx={{ maxWidth: '100%', fontFamily:'b_mitra' }} elevation={3}>
              {isAdmin &&
                <div style={{
                    display: 'inline-flex', 
                    textAlign: 'right', 
                    marginRight: 'auto',
                    marginLeft: 'auto'
                    }}>
                  <div>
                  <CardHeader
                    action={
                      <IconButton aria-label="settings" onClick={() => editMaterial()}>
                        <BorderColorIcon />
                      </IconButton>
                    }
                  />
                  </div>
                  <div>
                  <CardHeader
                    action={
                      <IconButton aria-label="settings" onClick={() => editBuyMaterial()}>
                        <EditNoteIcon />
                      </IconButton>
                    }
                  />
                  </div>
                </div>
              }
              <Link key={MatList.id} to={`/${authDataGroup?.name}/${MatList.id}`}>
                  {/* <div style={{visibility: imageLoading ? "hidden" : "visible"}}> */}
                    <CardMedia
                        // placeholder={(<Skeleton variant="rectangular" width='100%'  />)}
                        sx={{minHeight: 280, maxHeight: 330}}
                        component="img"
                        alt={MatList.material.alt_image}
                        image={String(MatList?.material?.image).startsWith(address_api) ? MatList.material.image : `${address_api}${MatList.material.image}`}
                        loading='lazy'
                        // onLoad={imageLoaded}
                      />
                  {/* </div> */}
                  <CardContent>
                      <Typography 
                          sx={{ 
                              fontFamily:'Segoe UI', 
                              textAlign:(authDataLang?.view_sts ? "left" : "right"),
                              }} 
                          gutterBottom 
                          variant="h4" 
                          component="div" 
                          >
                          <b>{MatList.material.name}</b>
                      </Typography>
                      <Typography sx={{ fontFamily:'Segoe UI' }} gutterBottom variant="h5" component="div">
                          {MatList.material.bio}
                      </Typography>
                      <Typography 
                          sx={{ 
                              fontFamily:'Segoe UI', 
                              textAlign: 'justify' 
                            }} 
                          variant="h6" 
                          color="text.secondary"
                          component="div"
                          >
                          {MatList.material.meta_description}
                      </Typography>
                  </CardContent>
              </Link>
              <CardActions sx={{ 
                    display: 'block',
                    marginRight: 5,
                    marginLeft: 5,
                    textAlign: 'right',
                  }}>
                  {/* <h2>قیمت : {MatList.sell_cash} تومان</h2> */}
                  <Typography
                      fontFamily='Segoe UI' 
                      component="h6"
                      variant="h6"
                      >
                      <b>{authDataLang?.site_langs?.desc_fee} : ({authDataLang?.site_langs?.desc_fee_call})</b>
                  </Typography>
              </CardActions>
              <CardActions sx={{ 
                    display: 'block',
                    marginRight: 5,
                    marginLeft: 5,
                    textAlign: 'right',
                  }}>
                <Button variant='contained' 
                  sx={{ 
                    fontFamily:'Segoe UI', 
                    textAlign: 'center',
                    height: '2rem',
                    padding: 3
                  }} 
                  color='secondary'
                  size="large" onClick={() => {reqFree()}}>
                    {/* <h2>ثبت سفارش</h2> */}
                    <Typography
                        fontFamily='b_mitra' 
                        component="div"
                        variant="h6"
                        >
                        <b>{authDataLang?.site_langs?.desc_req_ask}</b>
                    </Typography>
                </Button>
              </CardActions>
              <CardActions dir={authDataLang?.view_sts ? "ltr" : "rtl"} >
                  <Rating
                      name="hover-feedback"
                      value={value}
                      precision={0.5}
                      emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
                  />
                  {/* {value !== null && (
                      <Box sx={{ ml: 2, fontFamily:'Segoe UI' }}>{labels[hover !== -1 ? hover : value]}</Box>
                  )} */}
              </CardActions>
          </Card>

        {/* <LoginSys
          selectedValue={selectedValue}
          open={openDialog}
          onClose={handleDialodClose}
        /> */}
      </div>
  );
}

export default MatShowItem;